import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import config from '../../../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

class HirePurchaseOwner extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: [],
      isDataLoaded: false
    }
  }

  componentWillMount() {
    axios.get(`${appUrlPath}/getHirePurchaseOwner`, {
      params: {}
    })
    .then((res) => {
      this.setState({ option: res.data, isDataLoaded: true }, () => {});
    })
    .catch(() => {
    });
  }

  render() {
    return (
      <FormGroup controlId="hirePurchaseOwner">
        <Col componentClass={ControlLabel} sm={5}>
          Hire Purchase Owner
        </Col>
        <Col sm={7}>
          {this.state.isDataLoaded ?
            <div className="ebaoUtil__Container">
              <select
               className="custom-select"
               value={this.props.hirePurchaseOwner}
               onChange={this.props.handleChangeHirePurchaseOwner}
               id="hirePurchaseOwner"
              >
               <option value="">Please Select</option>
               {this.state.option.map((obj, index) => {
                 const counter = index
                 return (
                   <option
                     value={obj.code}
                     key={counter}
                   >{obj.name}</option>
                 );
               })}
             </select>
           </div> : <div>Loading</div>}
        </Col>
      </FormGroup>
    )
  }
}

HirePurchaseOwner.propTypes = {
  handleChangeHirePurchaseOwner: PropTypes.func,
  hirePurchaseOwner: PropTypes.string
};

export default HirePurchaseOwner;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/hirePurchaseOwner/HirePurchaseOwner.js